<template>
  <OrganismsSupportRegular />
  <OrganismsSupportShopping />
  <OrganismsSupportContact />
</template>

<script setup lang="ts">
/**
 * サポート導線の4コンテンツを1つにまとめたブロック。
 *
 * 1. 定期コース特典（`sec_footer-regular`）— `OrganismsSupportRegular`
 * 2. 定期コースのよくあるご質問（`regular-faq`）— `OrganismsSupportRegularFaq`
 * 3. お買い物サポート（`sec_footer-support`）— `OrganismsSupportShopping`
 * 4. お電話でのお問い合わせ（`sec_footer-contact`）— `OrganismsSupportContact`
 *
 * **2 は 1 の `section` の中に入る**ので、ここから直接呼ぶのは 1・3・4 の3つ。
 * 支給デザインの入れ子がそうなっており、`.sec_footer-regular` の `max-width` を効かせるため。
 *
 * **chrome ではなくページの中身**なので、`layouts/default.vue` ではなく
 * **載せるルートのページ側で置く**。載せる・載せないはルートごとに決まっており、
 * `docs/design-renewal/CONVERSION-GUIDE.md` §6「サポート導線4コンテンツ」の一覧（要 13 ルート / 不要 36 ルート）が正。
 *
 * CSS のクラス名が `sec_footer-*` なのは支給CSSがその名前で書かれているため。
 * **支給CSSは書き換えない方針なのでクラス名は据え置く**が、フッタの一部という意味ではない。
 *
 * 支給デザインではほぼ全ページ（83本中80本）に入っているが、
 * **不要と決めたルートからは落とす**（デザインを上書きする決定）。
 */
</script>
